import React from 'react'
import styled from 'styled-components'
import { CallSplit, SyncRounded, ErrorRounded } from '@material-ui/icons'
import { IconProps } from '@material-ui/core/Icon'
import { colors } from '../../styles'

export const StyledFlexRow = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  &:hover {
    background-color: ${colors.greenLight};
    cursor: pointer;
  }
`

export const StyledArchiveLabel = styled.div`
  all: unset;
  align-items: center;
  display: flex;
  max-width: calc(100% - 4.5em);
  padding: 8px 12px 8px 24px;
` as any

export const StyledLanguage = styled.span`
  background-color: ${colors.greyDavy};
  color: ${colors.white};
  font-size: 10px;
  margin-left: 1px;
  padding: 1px 2px;
  border-radius: 1px;
  text-transform: uppercase;
`

export const StyledFileTitle = styled.span`
  font-family: knowledge2017bold;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 100%;
  margin-right: -1px;
  color: ${colors.text};
`

export const StyledOverallPackTitle = styled(StyledFileTitle)`
  display: flex;
  align-items: center;
`

export const StyledFileExt = styled.span`
  font-family: knowledge2017bold;
  color: inherit;
`

export const StyledFileDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  padding: 4px 0 0 20px;
`

export const StyledCallSplit = styled(({ error, ...props }) => (
  <CallSplit {...props} />
))`
  color: ${({ error }) => (error ? colors.error : colors.green)};
  font-size: 16px;
` as React.ComponentType<IconProps & { error: boolean }>

export const StyledRotatedSyncRounded = styled(SyncRounded)`
  animation: spin 3s linear infinite;
  @keyframes spin {
    100% {
      transform: rotate(-360deg);
    }
  }
` as any

export const StyledWrapper = styled.div`
  display: flex;
  margin-left: auto;
  svg {
    font-size: 16px;
  }
` as React.ComponentType<any>

export const StyledErrorRounded = styled(ErrorRounded)`
  color: ${colors.error};
` as React.ComponentType<any>
